'use strict';

Object.defineProperty(exports, '__esModule', { value: true });

function _interopDefault (ex) { return (ex && (typeof ex === 'object') && 'default' in ex) ? ex['default'] : ex; }

const styled = require('styled-components');
const styled__default = _interopDefault(styled);
const breakpoints = require('../../../style/breakpoints.js');
const button = require('../../Button/button.js');

var CloseButtonContainer = styled__default(button).withConfig({
  displayName: "closeButtonstyle__CloseButtonContainer",
  componentId: "sc-73naeh-0"
})(["background-color:rgba(0,0,0,0.5);border-radius:50%;padding-left:12px;padding-right:12px;position:absolute;right:1px;top:1px;z-index:1;&:hover{background-color:rgba(0,0,0,1);}&:focus{box-shadow:0 0 0 3px rgba(0,137,255,0.65);outline:none;}@media(min-width:", "){right:-42px;top:-42px;}"], breakpoints.lg);

exports.CloseButtonContainer = CloseButtonContainer;
